import "core-js/modules/es.number.constructor.js";
//
//
//
//
//

export default {
  props: {
    animation: String,
    digit: [String, Number]
  }
};